var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDiamond = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7971 11.56L24.9179 5.17083C24.383 4.58619 23.6278 4.25224 22.8354 4.25H11.1621C10.3697 4.25224 9.61443 4.58619 9.07957 5.17083L3.2004 11.56C2.96095 11.8234 2.82945 12.1673 2.83207 12.5233V12.9483C2.83142 13.2793 2.9467 13.6001 3.1579 13.855L15.9079 29.24C16.1776 29.5638 16.5774 29.7507 16.9987 29.75C17.4201 29.7507 17.8199 29.5638 18.0896 29.24L30.8396 13.855C31.0508 13.6001 31.166 13.2793 31.1654 12.9483V12.5233C31.168 12.1673 31.0365 11.8234 30.7971 11.56ZM15.8371 24.7492L6.41623 13.4158C6.23236 13.3415 6.14356 13.1322 6.21789 12.9483C6.29222 12.7645 6.50153 12.6757 6.68539 12.75H11.7146C12.3533 12.7187 12.9338 13.1193 13.1312 13.7275L16.5171 24.4233C16.607 24.6111 16.5278 24.8363 16.34 24.9262C16.1522 25.0162 15.927 24.9369 15.8371 24.7492ZM18.5146 12.75H27.2554C27.3954 12.7482 27.5211 12.6641 27.5763 12.5354C27.6314 12.4067 27.6056 12.2576 27.5104 12.155L23.1046 7.36667C23.0374 7.29282 22.9423 7.25072 22.8425 7.25072C22.7427 7.25072 22.6475 7.29282 22.5804 7.36667L18.2454 12.155C18.1484 12.2595 18.1235 12.412 18.1823 12.5419C18.2411 12.6719 18.372 12.7539 18.5146 12.75Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiamond, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/diamond.c746d132.svg";
export { ForwardRef as ReactComponent };